<template>
  <div class="w-100">
    <div v-if="isLoading" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
      <div v-if="errorMessage" class="py-3">
        <ErrorMessage :message="errorMessage" />
      </div>
      <template v-else>
        <p class="mb-3 body-1-4">Shipped From</p>
        <div class="w-100">
          <!-- Merchant Location -->
          <div class="d-flex align-items-center">
            <div class="flex-shrink-0 mr-3">
              <svg width="30" height="auto" viewBox="0 0 40 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.9704 20.8801C7.90252 20.8801 9.59094 19.9963 10.6527 18.5928C11.6971 19.9963 13.3855 20.8801 15.3177 20.8801C17.2672 20.8801 18.9556 19.9963 19.9999 18.5928C21.0444 19.9963 22.7328 20.8801 24.6823 20.8801C26.6319 20.8801 28.3029 19.9963 29.3646 18.5928C30.4091 19.9963 32.0975 20.8801 34.0296 20.8801C37.3717 20.8801 40 18.2636 40 14.9713V14.6767C40 14.0009 39.8259 13.3944 39.4777 12.8053L34.8651 4.95577V3.51756C34.8651 1.31692 33.5074 0 31.262 0H8.75543C6.51 0 5.1349 1.31692 5.1349 3.51756V4.95577L0.522192 12.8053C0.174065 13.3944 0 14.0009 0 14.6767V14.9713C0 18.2636 2.62837 20.8801 5.9704 20.8801ZM7.76326 4.41861V4.00274C7.76326 3.13634 8.26806 2.61651 9.12096 2.61651H30.8791C31.732 2.61651 32.2367 3.13634 32.2367 4.00274V4.41861H7.76326ZM3.01131 13.6544L6.7885 7.03511H33.0722L36.9538 13.6544H3.01131ZM2.61096 16.0976H9.32985C8.94691 17.5011 7.76326 18.4369 5.9704 18.4369C4.17754 18.4369 2.9939 17.5011 2.61096 16.0976ZM11.9756 16.0976H18.6771C18.2941 17.5011 17.1105 18.4369 15.3177 18.4369C13.5422 18.4369 12.3412 17.5011 11.9756 16.0976ZM21.3229 16.0976H28.0418C27.6588 17.5011 26.4752 18.4369 24.6823 18.4369C22.8895 18.4369 21.7058 17.5011 21.3229 16.0976ZM30.6876 16.0976H37.3891C37.0061 17.5011 35.8225 18.4369 34.0296 18.4369C32.2541 18.4369 31.053 17.5011 30.6876 16.0976ZM6.91035 37.9827H33.0896C35.5613 37.9827 37.0061 36.5792 37.0061 34.1533V19.4418L34.2036 19.5459V33.4428C34.2036 34.5691 33.6118 35.1929 32.4978 35.1929H7.51958C6.40557 35.1929 5.79634 34.5691 5.79634 33.4428V19.5285L2.9939 19.4939V34.1533C2.9939 36.5792 4.43864 37.9827 6.91035 37.9827ZM8.56396 36.8391H18.6074V25.472C18.6074 24.6749 18.0853 24.155 17.2846 24.155H9.90426C9.10357 24.155 8.56396 24.6749 8.56396 25.472V36.8391ZM21.8799 24.5536V29.4401C21.8799 30.2544 22.402 30.757 23.2202 30.757H30.2872C31.0879 30.757 31.5926 30.2544 31.5926 29.4401V24.5536C31.5926 23.7392 31.0879 23.2366 30.2872 23.2366H23.2202C22.402 23.2366 21.8799 23.7392 21.8799 24.5536Z"
                  class="fill-primary" />
              </svg>
            </div>
            <div class="w-100 text-truncate d-block">
              <p class="mb-0 body-2-4 text-truncate">{{ getMerchant.name }}</p>
              <p v-if="isAddressNotValid" class="mb-0 body-3">Set the delivery address first.</p>
              <p v-else class="mb-0 body-3">{{ deliveryDetail.distance_text }} From your location</p>
            </div>
          </div>
    
          <!-- Line -->
          <div class="w-100" style="padding-left: 14px;">
            <div class="w-100" style="height: 30px;border-left: 3px dotted #7C7C7C !important;"></div>
          </div>
    
          <!-- Guest Locations -->
          <div @click="toggleDetailForm" class="d-flex align-items-center justify-content-between mb-4">
            <div class="">
              <svg width="30" height="auto" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M14.7368 10.8064C14.7368 9.43255 13.6236 8.31934 12.2507 8.31934C10.8769 8.31934 9.76367 9.43255 9.76367 10.8064C9.76367 12.1792 10.8769 13.2924 12.2507 13.2924C13.6236 13.2924 14.7368 12.1792 14.7368 10.8064Z"
                  stroke="#d9534f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.2498 21.25C12.2498 21.25 4.97391 16.5108 4.79058 10.5973C4.66185 6.4451 8.12963 2.75008 12.2498 2.75008C16.3699 2.75008 19.8368 6.44504 19.7099 10.5973C19.5255 16.632 12.2498 21.25 12.2498 21.25Z"
                  stroke="#d9534f" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </div>
            <div class="w-100 text-truncate px-3 d-block">
              <template v-if="isAddressNotValid">
                <p class="mb-0 body-2-4 text-truncate">Delivery Address</p>
                <p class="mb-0 body-3 text-truncate">Click here to set your delivery address.</p>
              </template>
              <template v-else>
                <p class="mb-0 body-2-4 text-truncate">{{ deliveryDetail.short_name }}</p>
                <p class="mb-0 body-3 text-truncate">{{ deliveryDetail.destination_text }}</p>
              </template>
            </div>
            <button class="g-btn g-btn-primary-outline g-btn-sm">
              {{ isAddressNotValid ? 'Setup' : 'Edit' }}
            </button>
          </div>
    
          <!-- Address Detail -->
          <div class="w-100" @click="toggleDetailForm">
            <p class="body-3 mb-1">Address Detail</p>
            <div class="w-100 d-flex align-items-start p-3 border-form rounded">
              <svg class="mr-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="directions_24px">
                  <path id="icon/maps/directions_24px" fill-rule="evenodd" clip-rule="evenodd"
                    d="M22.4275 10.5931L13.4175 1.58312C12.6675 0.833125 11.3475 0.823125 10.5875 1.58312L1.58746 10.5831C0.807457 11.3631 0.807457 12.6231 1.58746 13.4031L10.5875 22.4031C10.9775 22.7931 11.4875 22.9831 11.9975 22.9831C12.5075 22.9831 13.0175 22.7931 13.4075 22.4031L22.3975 13.4131C23.1875 12.6531 23.1975 11.3931 22.4275 10.5931ZM12.0075 20.9931L3.00746 11.9931L12.0075 2.99312L21.0075 11.9931L12.0075 20.9931ZM7.99746 15.0031V11.0031C7.99746 10.4531 8.44746 10.0031 8.99746 10.0031H13.9975V7.50312L17.4975 11.0031L13.9975 14.5031V12.0031H9.99746V15.0031H7.99746Z"
                    class="fill-primary" />
                </g>
              </svg>
              <p class="body-2-2 mb-0">{{ this.$isNotEmptyV2(deliveryDetail.landmark) ? deliveryDetail.landmark : '-'  }}</p>
            </div>
          </div>
        </div>
      </template>
    </template>
    
    <popup-detail
      direction="bottom" 
      :show="showDetailForm"
      use_max_size
      :title="detailViewType == 'map' ? '' : 'Search location'"
      wrapper_size="mobile"
      :use_footer="detailViewType == 'map'"
      @close="toggleDetailForm">

      <template v-slot:body>
        <div class="w-100">
          <template v-if="detailViewType == 'map'">
            <div v-if="detailMapStatus.isLoading" class="w-100 py-5 text-center">
              <loader />
            </div>
            <template v-else>
              <template v-if="detailMapStatus.error != ''">
                <div class="p-4 border-form" style="background-color: #f8f8f8;">
                  <div class="w-100 rounded p-3 d-flex align-items-start" :class="{
                    'error-message' : !isGPSAllowed,
                    'warning-message' : detailMapStatus.error != ''
                  }">
                    <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path class="colored-path" d="M3.90744 26.8446H26.0926C28.5258 26.8446 30 25.1774 30 23.0157C30 22.3517 29.7996 21.6593 29.4418 21.0377L18.3349 1.93564C17.5906 0.649921 16.3168 0 14.9999 0C13.6832 0 12.395 0.649921 11.6651 1.93564L0.558206 21.0377C0.171756 21.6735 0 22.3517 0 23.0157C0 25.1774 1.47424 26.8446 3.90744 26.8446Z"/>
                      <path d="M15.0143 17.4066C14.27 17.4066 13.855 16.9827 13.8406 16.2339L13.6546 8.54788C13.6403 7.79907 14.1985 7.26218 14.9999 7.26218C15.7729 7.26218 16.374 7.8132 16.3597 8.56202L16.1451 16.2339C16.1307 16.9969 15.7157 17.4066 15.0143 17.4066ZM15.0143 22.1398C14.1555 22.1398 13.4113 21.4616 13.4113 20.628C13.4113 19.7802 14.1412 19.1021 15.0143 19.1021C15.8731 19.1021 16.6031 19.7661 16.6031 20.628C16.6031 21.4757 15.8588 22.1398 15.0143 22.1398Z" fill="white"/>
                    </svg>
                    <div class="pl-3">
                      <p class="body-2-4 mb-1">{{ detailErrorMessage.title }}</p>
                      <p class="body-3 mb-0">{{ detailErrorMessage.subtitle }}</p>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="w-100 position-relative radius-12-t overflow-hidden">
                  <div class="w-100" :key="detailMap.keyUpdate">
                    <gmap-map
                      v-if="$isNotEmptyV2(detailMap.center)"
                      :center="detailMap.center" 
                      :options="detailMap.config"
                      :zoom="15" 
                      style="width:100%;  
                      height: 300px;"
                      @center_changed="handleMapCenterChange">
                      <gmap-marker :position="detailMap.selected"></gmap-marker>
                    </gmap-map>
                  </div>
                  <div class="my-location" @click="getDetailCurrentLocation">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="my_location_24px">
                    <path id="icon/maps/my_location_24px" fill-rule="evenodd" clip-rule="evenodd" d="M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM5 12C5 15.87 8.13 19 12 19C15.87 19 19 15.87 19 12C19 8.13 15.87 5 12 5C8.13 5 5 8.13 5 12Z" class="fill-primary"/>
                    </g>
                    </svg>
                  </div>
                </div>

                <div class="w-100 p-4">
                  <div class="d-flex justify-content-between mb-3 align-items-center">
                    <p class="mb-0 body-1-4">Full Address</p>
                    <button class="g-btn g-btn-secondary g-btn-sm px-4 " @click="toogleDetailViewType('search')">Find</button>
                  </div>
                  <div class="p-3 radius-12 bg-white box-shadow-light-aff border-form">
                    <p class="mb-0 body-2-4 mb-1">Address Detail</p>
                    <p class="mb-0 body-2-2 mb-4">{{ detailAddress.destination_text }}</p>
                    <div class="d-flex radius-12 border-form p-3 justify-content-between">
                      <div class="align-items-center lh-1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g id="directions_24px">
                            <path id="icon/maps/directions_24px" fill-rule="evenodd" clip-rule="evenodd"
                              d="M22.4275 10.5931L13.4175 1.58312C12.6675 0.833125 11.3475 0.823125 10.5875 1.58312L1.58746 10.5831C0.807457 11.3631 0.807457 12.6231 1.58746 13.4031L10.5875 22.4031C10.9775 22.7931 11.4875 22.9831 11.9975 22.9831C12.5075 22.9831 13.0175 22.7931 13.4075 22.4031L22.3975 13.4131C23.1875 12.6531 23.1975 11.3931 22.4275 10.5931ZM12.0075 20.9931L3.00746 11.9931L12.0075 2.99312L21.0075 11.9931L12.0075 20.9931ZM7.99746 15.0031V11.0031C7.99746 10.4531 8.44746 10.0031 8.99746 10.0031H13.9975V7.50312L17.4975 11.0031L13.9975 14.5031V12.0031H9.99746V15.0031H7.99746Z"
                              class="fill-primary" />
                          </g>
                        </svg>
                      </div>
                      <input class="border-0 no-focus-border align-items-center w-90 body-2-2" v-model="detailMap.landmark" placeholder="Add landmark">
                    </div>
                  </div>
                  
                  
                  <div class="w-100 mb-3">
                  </div>
                </div>
              </template>
            </template>
          </template>
          <template v-else>
            <div class="w-100 px-4 pt-4 border-t-form" style="height: 50vh;overflow-y: auto;">
              <div class="w-100 mb-4 pb-4 border-b-form-dashed-2">
                <div class="w-100 mb-3 border-form radius-6 p-3 d-flex justify-content-between">
                  <input ref="input_find_location" type="text" class="border-0 align-items-center no-focus-border w-90 body-2-1" placeholder="Search location" v-model="detailMap.search.keyword">
                  <div v-if="detailMap.search.keyword != ''" class="align-items-center lh-1" @click="detailMap.search.keyword = ''">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_587_22)">
                        <path
                          d="M0.228308 13.7716C0.537114 14.0717 1.04885 14.0717 1.34883 13.7716L6.99557 8.12491L12.6423 13.7716C12.9423 14.0717 13.4629 14.0805 13.7628 13.7716C14.0628 13.4629 14.0628 12.9599 13.7628 12.66L8.1161 7.0044L13.7628 1.35766C14.0628 1.05767 14.0717 0.545937 13.7628 0.245954C13.454 -0.0628521 12.9423 -0.0628521 12.6423 0.245954L6.99557 5.8927L1.34883 0.245954C1.04885 -0.0628521 0.528291 -0.0716751 0.228308 0.245954C-0.0716751 0.55476 -0.0716751 1.05767 0.228308 1.35766L5.87505 7.0044L0.228308 12.66C-0.0716751 12.9599 -0.0804984 13.4717 0.228308 13.7716Z"
                          fill="black" fill-opacity="0.85" />
                      </g>
                      <defs>
                        <clipPath id="clip0_587_22">
                          <rect width="13.9911" height="14" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
                <button class="g-btn g-btn-secondary-outline g-btn-sm px-4 align-items-center" @click="toggleDetailForm('map')">Select via map</button>
              </div>
              <div class="w-100">
                <div v-if="detailMap.search.isLoading" class="py-4 text-center">
                  <loader/>
                </div>
                <template v-else>
                  <div class="w-100">
                    <ErrorMessage v-if="detailMap.search.error != ''" :message="detailMap.search.error" />
                    <template v-else>
                      <div class="w-100 mb-3 pb-3 border-b-form" v-for="place in detailMap.search.result" @click="selectPlace(place.location.lat, place.location.lng)">
                        <p class="body-2-4 mb-0">{{ place.name }}</p>
                        <p class="body-3 mb-0">{{ place.formatted_address }}</p>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </template>
      
      <template v-slot:footer>
	    	<div class="p-4 border-t-form">
		    	<state-button
		    	 	:click="saveDeliveryAddress" 
						size="lg"
						variant="primary"
						block >
						Save Address
					</state-button>
				</div>
			</template>
    </popup-detail>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import { post, get } from "@/services/index.js";

  export default {
    data(){
      return{
        isLoading: true,
        locationNotAvailable: true,
        errorMessage: "",
        showDetailForm: false,
        isGPSAllowed: false,
        detailViewType: 'map',
        detailMapStatus: {
          isLoading: false,
          error: ''
        },
        detailAddress: { },
        isDetailCurrentLocationAllowed: false,
        detailMap:{
          config: {
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoomControl: false,
            panControl: false,
            rotateControl: false,
            scaleControl: false,
            gestureHandling: 'greedy'
          },
          center: {},
          selected: {},
          isLoading: null,
          keyUpdate: 0,
          landmark: "",
          search: {
            isLoading: false,
            error: '',
            result: [],
            keyword: "",
            debounceTimer: null
          }
        }
      }
    },
    computed:{
      ...mapGetters(['getMerchant', 'getRestaurantDelivery']),
      deliveryDetail(){
        const isDetailValid = this.$isNotEmptyV2(this.getRestaurantDelivery.detail);
        return isDetailValid ? this.getRestaurantDelivery.detail : {};
      },
      detailErrorMessage(){
        if(!this.isGPSAllowed){
          return {
            title: 'Permission Denied', 
            subtitle: 'Tidak bisa mendapatkan lokasi anda saat ini. Mohon izinkan untuk mengakses lokasi'
          }
        }else if(this.detailMapStatus.error) {
          return {
            title: 'Something Wrong', 
            subtitle: this.detailMapStatus.error
          }
        }

        return {title: '', subtitle: ''}
      },
      searchLocationKeyword(){
        return this.detailMap.search.keyword;
      },
      isAddressNotValid(){
        if(this.$isNotEmptyV2(this.getRestaurantDelivery.detail)) return false;
        return this.locationNotAvailable;
      }
    },
    watch:{
      searchLocationKeyword(){
        if(this.detailViewType === 'search'){
          this.findPlace()
        }
      }
    },
    mounted(){
      this.loadSavedData();
    },
    methods:{
      ...mapMutations(['setRestaurantDeliveryDetail']),
      async loadSavedData(){
        try {
          this.isLoading = true
          this.error = ""
          
          const isDetailValid = this.$isNotEmptyV2(this.getRestaurantDelivery.detail);
          if(isDetailValid){
            this.locationNotAvailable = false;
            return
          };
          
          const currentLocation = await this.getCurrentLocation();
          const { latitude, longitude } = currentLocation
          const detailDelivery = await this.getDetailDelivery(latitude, longitude);
          const shorNameLocation = await this.getShortCurrentName(latitude, longitude) 
          this.setRestaurantDeliveryDetail({...detailDelivery, short_name: shorNameLocation});
          this.locationNotAvailable = false;
        } catch (error) {
          if(this.$isNotEmptyV2(error.code)) this.locationNotAvailable = true
          else this.errorMessage = error.message
        } finally {
          this.isLoading = false
        }
      },
      getCurrentLocationApi(){
        return new Promise((resolve, reject) => {
          if(!navigator.geolocation) reject({message: "The browser does not support the Geolocation API."});
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords; 
              resolve({ latitude, longitude })
            },
            (error) => {
              let errorResponse = {
                code: error.code,
                message: error.message
              };
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  errorResponse.message = "Izin untuk mendapatkan lokasi ditolak oleh pengguna.";
                  break;
                case error.POSITION_UNAVAILABLE:
                  errorResponse.message = "Informasi lokasi tidak tersedia.";
                  break;
                case error.TIMEOUT:
                  errorResponse.message = "Waktu permintaan lokasi habis.";
                  break;
                case error.UNKNOWN_ERROR:
                  errorResponse.message = "Terjadi kesalahan yang tidak diketahui.";
                  break;
              }
              reject(errorResponse)
            },
            {
              maximumAge: 0
            }
          );
        });
      },
      async getCurrentLocation(){
        try {
          return  await this.getCurrentLocationApi();
        } catch (error) {
          throw error.code;
        }
      },
      async getDetailDelivery(lat,long){
        try {

          const apiParams = { lat, long, merchant_id : this.getMerchant.id }
          const apiResponse = await post("CORE_RESTO", "v2/delivery-fee", apiParams);
          const { success, message, data } =  apiResponse.data

          if(!success) throw new Error(message);
          
          return data;
        } catch (error) {
          throw error;
        }
      },
      async getShortCurrentName(lat,long){
        try {

          const apiParams = { lat, long }
          const apiResponse = await get("CORE", "user-location", apiParams);
          const { success, message, data } =  apiResponse.data

          if(!success) throw new Error(message);
          
          return this.getValidShortName(data.address_components);
        } catch (error) {
          throw error;
        }
      },
      getValidShortName(addressComponents) {
        for (const component of addressComponents) {
          if (!component.types.includes("plus_code") && component.short_name) {
            return component.short_name;
          }
        }
        return "-";
      },

      // DETAIL
      toggleDetailForm(){
        this.showDetailForm = !this.showDetailForm
        if(this.showDetailForm){
          this.toogleDetailViewType('map')
          this.getDetailLocation();
        }
      },
      toogleDetailViewType(newViewType){
        this.detailViewType = newViewType;
        if(newViewType === 'search'){
          this.detailMap.search = {
            isLoading: false,
            error: '',
            result: [],
            keyword: "",
            debounceTimer: null
          }
        }
      },
      async getDetailLocation(latitude = null, longitude = null){
        try {
          this.detailMapStatus = { isLoading : true, error: '' }

          const savedDetail = this.getRestaurantDelivery.detail;
          if(this.$isNotEmptyV2(savedDetail)){
            this.detailAddress = savedDetail;
            await this.setDetailMapPosition(savedDetail.destination_position[0], savedDetail.destination_position[1])
            this.detailMap.landmark = this.$isNotEmptyV2(this.detailAddress.landmark) ? this.detailAddress.landmark : ""
            this.detailMapStatus.isLoading = false;
            return;
          }
          
          const { latitude : resultLat, longitude : resultLong } = this.$isEmpty(latitude) ? await this.getCurrentLocationApi() : { latitude, longitude }; 
          
          this.detailAddress = await this.getDetailDelivery(resultLat, resultLong);

          await this.setDetailMapPosition(resultLat, resultLong)
          this.detailMap.landmark = this.$isNotEmptyV2(this.detailAddress.landmark) ? this.detailAddress.landmark : ""
          
        } catch (error) {
          if(this.$isNotEmptyV2(error.code)){
            console.log("ABC");
            const { lat, lng } = this.getMerchant;
            await this.getDetailLocation(lat, lng)
          }
          else {
            console.log(error);
            this.detailMapStatus.error = error.message
          }
        } finally {
          this.detailMapStatus.isLoading = false;
        }
      },
      handleMapCenterChange(newPosition){
        const { lat, lng } = { lat: newPosition.lat(), lng: newPosition.lng() };
        this.detailMap.selected = {lat, lng}
        if (this.detailMap.isLoading) {
          clearTimeout(this.detailMap.isLoading);
        }

        this.detailMap.isLoading = setTimeout(async () => {
          try {
            const newAddress = await this.getDetailDelivery(lat, lng);
            const completeAddress = {...newAddress, landmark: this.detailAddress.landmark}
            this.detailAddress = completeAddress
          } catch (error) {
            console.log("ERROR handleMapCenterChange(): ", error.message);
          }
        }, 500);
      },
      async setDetailMapPosition(lat, lng, updateSavedAddres=false){
        try {
          this.detailMap.selected = { lat, lng }
          this.detailMap.center = { lat, lng }
          this.detailMap.keyUpdate++
          if(updateSavedAddres) {
            const newAddress = await this.getDetailDelivery(lat, lng);
            this.detailAddress = {...newAddress}
          }
        } catch (error) {
          console.log("ERROR setDetailMapPosition(): ", error.message);
        }
      },
      async getDetailCurrentLocation(){
        try {
          const { latitude, longitude } = await this.getCurrentLocationApi();
          await this.setDetailMapPosition(latitude, longitude, true);
        } catch (error) {
          console.log("ERROR setDetailMapPosition(): ", error.message);
        }
      },
      async saveDeliveryAddress(){
        try {
          const { destination_position: currentPosition = ["",""] } = this.detailAddress;
          const { destination_position: savedPosition = ["",""], landmark: savedLandmark = "" } = this.$isNotEmptyV2(this.getRestaurantDelivery.detail) ? this.getRestaurantDelivery.detail : {};
  
          const isLatitudeChanges = currentPosition[0] !== savedPosition[0]
          const isLongitudeChanges = currentPosition[1] !== savedPosition[1]
          
          const isPositionChanges = isLatitudeChanges || isLongitudeChanges
          const isLandmarkChanges = savedLandmark !== this.detailMap.landmark
          
          if(!isPositionChanges && !isLandmarkChanges) return Promise.resolve();
          
          let deliveryDetail = this.detailAddress
          if(isPositionChanges){
            const shorNameLocation = await this.getShortCurrentName(currentPosition[0], currentPosition[1]);
            deliveryDetail.short_name = shorNameLocation
          }
          if(isLandmarkChanges){
            deliveryDetail.landmark = this.detailMap.landmark
          }
          this.setRestaurantDeliveryDetail(deliveryDetail);
          
        } catch (error) {
          console.log("ERROR saveDeliveryAddress(): ", error.message);
        } finally {
          this.toggleDetailForm();
          return Promise.resolve();
        }
      },
      findPlace(){
        if (this.detailMap.search.debounceTimer) {
          clearTimeout(this.detailMap.search.debounceTimer);
        }

        this.detailMap.search.debounceTimer = setTimeout(() => {
          if(this.detailMap.search.keyword != ''){
            this.getPlaceFromGmaps() 
          }
        }, 500);
      },
      async getPlaceFromGmaps(){
        try {
          this.detailMap.search.isLoading = true
          this.detailMap.search.error = ""
          this.detailMap.search.result = []

          const responseApi = await get("CORE_HOTEL", "maps-search", {
            text_search: this.detailMap.search.keyword
          })
          const { success, data, message } =  responseApi.data
          if(!success) throw new Error(message);
          this.detailMap.search.result = data;
          
        } catch (error) {
          this.detailMap.search.error = error.message 
        } finally {
          this.detailMap.search.isLoading = false
        }
      },
      selectPlace(latitude, longitude){
        this.toogleDetailViewType('map')
        this.setDetailMapPosition(latitude, longitude, true);
      },
    }
  }
</script>
<style setup>
.error-message{
  background-color: #fdedee;
}
.error-message > svg .colored-path {
  fill: #f04e5e !important;
}
.warning-message{
  background-color: #fff9e9;
}
.warning-message > svg .colored-path {
  fill: #FEC12C !important;
}
.my-location{
  position: absolute; 
  bottom: 18px;
  right: 18px;
  height: 45px;
  width: 45px;
  display: grid;
  place-items: center;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #ccc;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/general/DeliveryForm.vue